import { AxiosError } from 'axios';
import { createAsyncAction, ActionType, createAction } from 'typesafe-actions';
import {
  AnalysisHistoryData,
  AnalysisHistoryLogData,
  AnalysisHistoryState
} from '../models/analysisHitoryModel';

const LIST_REQUEST = 'anls/hstry/LIST_REQUEST';
const LIST_SUCCESS = 'anls/hstry/LIST_SUCCESS';
const LIST_FAILURE = 'anls/hstry/LIST_FAILURE';

const LOG_REQUEST = 'anls/hstry/LOG_REQUEST';
const LOG_SUCCESS = 'anls/hstry/LOG_SUCCESS';
const LOG_FAILURE = 'anls/hstry/LOG_FAILURE';

const DETAIL_REQUEST = 'anls/hstry/DETAIL_REQUEST';
const DETAIL_SUCCESS = 'anls/hstry/DETAIL_SUCCESS';
const DETAIL_FAILURE = 'anls/hstry/DETAIL_FAILURE';

const DISPATCH_SEARCH = 'amls/hstry/DISPATCH_SEARCH';

const LIST_INIT = 'anls/hstry/LIST_INIT';

export const dispatchSearch =
  createAction(DISPATCH_SEARCH)<{ searchParams: string }>();

export const list = createAsyncAction(LIST_REQUEST, LIST_SUCCESS, LIST_FAILURE)<
  AnalysisHistoryState,
  { data: AnalysisHistoryData[]; count: number; total: number },
  AxiosError
>();

export const log = createAsyncAction(LOG_REQUEST, LOG_SUCCESS, LOG_FAILURE)<
  string,
  { log: AnalysisHistoryLogData[] },
  AxiosError
>();

export const detail = createAsyncAction(
  DETAIL_REQUEST,
  DETAIL_SUCCESS,
  DETAIL_FAILURE
)<string, { detail: AnalysisHistoryData }, AxiosError>();

export const LIST_INITAL = createAction(LIST_INIT)();

const actions = {
  list,
  detail,
  log,
  dispatchSearch,
  LIST_INITAL
};

export type AnalysisHistoryAction = ActionType<typeof actions>;
